import { toaster } from 'evergreen-ui';

const showError = (message, options = {}) => {
  toaster.danger(message, options);
};

const showSuccess = (message, options = {}) => {
  toaster.success(message, options);
};

const showWarning = (message, options = {}) => {
  toaster.warning(message, options);
};

const showExtractedError = (error, errorPrefix = null, options = {}) => {
  const errorMessage = extractErrorMessage(error);

  showError(errorPrefix ? `${errorPrefix}${errorMessage}` : errorMessage, options);
};

const extractErrorMessage = (error) => {
  if (typeof error === 'string') {
    return error;
  }

  if (typeof error === 'object') {
    if (error.status === 401) {
      return 'Please log out and back in, and try again.';
    }

    if (error.data) {
      if (typeof error.data === 'string') {
        return error.data;
      }
      
      if (typeof error.data === 'object') {
        if (error.data.message && typeof error.data.message === 'string') {
          return error.data.message;
        }

        if (error.data.error && typeof error.data.error === 'object') {
          if (error.data.error.message && typeof error.data.error.message === 'string') {
            return error.data.error.message;
          }
        }
      }
    }

    if (error.message && typeof error.message === 'string') {
      return error.message;
    }
  }

  return 'Unknown error. Please reload the page and try again.';
};

export default {
  showError,
  showSuccess,
  showWarning,
  showExtractedError,
};
